
namespace TabAurous.Production{

    @Serenity.Decorators.registerClass()
    export class WIPMovementSelectGrid extends _Ext.GridBase<WIPMovementRow, any> {
   
        protected getColumnsKey() { return 'Production.WIPMovement'; }
        protected getDialogType() { return WIPMovementDialog; }
        protected getIdProperty() { return WIPMovementRow.idProperty; }
        protected getInsertPermission() { return WIPMovementRow.insertPermission; }
        protected getLocalTextPrefix() { return WIPMovementRow.localTextPrefix; }
        protected getService() { return WIPMovementSelectService.baseUrl; } 
        private autoSize;


        constructor(container: JQuery, options) {
            super(container, options);
            //var T = options.GridFilters.AttributeId;
            if (!isNaN(options.GridFilters.DepartmentId))
                (this.view.params as TransactionRequest).DepartmentId = options.GridFilters.DepartmentId;
            if (!isNaN(options.GridFilters.ProcessId))
                (this.view.params as TransactionRequest).ProcessId = options.GridFilters.ProcessId;

            if (!isNaN(options.GridFilters.PartyId))
                (this.view.params as TransactionRequest).PartyId = options.GridFilters.PartyId;

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.titleDiv.hide();
        } 
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);

            return grid;
        }
         

        get selectedItems(): WIPMovementRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;
            
            return true;

        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}